import {inject, Injectable, Injector} from '@angular/core';
import {Auth, signInWithCustomToken, signInWithEmailAndPassword, User} from "@angular/fire/auth";
import {ActivatedRoute, Router} from "@angular/router";
import {InteractionRequiredAuthError, PublicClientApplication} from "@azure/msal-browser";
import {RepoService} from "./repo.service";
import {environment} from "../../environments/environment.development";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  authFirebase = inject(Auth);
  userEmail: string = "";
  firebaseUser: User
  readonly router = inject(Router)
  readonly route = inject(ActivatedRoute)
  private injector = inject(Injector);
  private repoService = inject(RepoService);

  msalInstance = new PublicClientApplication({
    auth: {
      clientId: environment.msal.CLIENT_ID,
      authority: environment.msal.AUTHORITY,
      knownAuthorities: environment.msal.KNOWN_AUTHORITIES,
      redirectUri: environment.msal.REDIRECT_URL,
      postLogoutRedirectUri: environment.msal.REDIRECT_URL
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true
    }
  });


  constructor() {
    console.log(this.msalInstance);
    this.msalInstance.initialize()
      .then(() => {
        console.log("MSAL Initialized Successfully");
      })
      .catch(error => {
        console.error("MSAL Initialization Failed:", error);
      });
  }

  // Promise that resolves when the first auth state check is complete
  private resolveAuthInit!: () => void;
  public authInitialized = new Promise<void>((resolve) => {
    this.resolveAuthInit = resolve;
  });


  getCurrentPath(): string {
    return window.location.pathname;
  }

  initAuthState() {
    this.authFirebase.onAuthStateChanged(async (state) => {
      console.log("[AuthService] onAuthStateChanged:", state ? `User ${state.email} is authenticated` : "State is null");
      const currentPath = this.getCurrentPath();

      if (state == null) {
        console.warn("[AuthService] Auth state is null. Checking if we need to navigate to root.");
        this.firebaseUser = null;
        this.repoService.stopAdminUserListener();

        // Release the promise so guards can run (they will see null user and redirect to login)
        this.resolveAuthInit();

        // If we are deep-linked but signed out, kick to login!
        if (currentPath !== '/' && currentPath !== '') {
          console.warn(`[AuthService] Current path is ${currentPath}. Navigating to root.`);
          console.trace("[AuthService] Stack trace for null auth state redirect:");
          await this.router.navigate([''], {relativeTo: this.route});
        } else {
          console.log("[AuthService] Already at root (or unparsed). No navigation needed.");
        }
      } else {
        this.userEmail = state.email;
        let userId = state.uid;

        this.firebaseUser = state;

        await this.repoService.startAdminUserListener(userId);

        // Release the promise so guards can run (they will now see the populated user)
        this.resolveAuthInit();

        // ONLY REDIRECT TO STATISTICS IF WE ARE ACTUALLY ON THE LOGIN PAGE (ROOT)
        // If we represent a deep link (reload), stay there!
        if (currentPath === '/' || currentPath === '') {
          console.log("[AuthService] Authenticated on root. Redirecting to appStatistics.");
          await this.router.navigate(['/main/appStatistics']);
        } else {
          console.log(`[AuthService] Authenticated on deep link ${currentPath}. Staying there.`);
        }
      }
    })
  }

  async signOut() {
    console.warn("[AuthService] signOut() called. Originating from:");
    console.trace();
    this.repoService.stopAdminUserListener();
    await this.authFirebase.signOut();
  }

  async signInWithMicrosoft() {

    console.log("QQQ");
    console.log(this.msalInstance);
    try {
      const loginRequest = {
        scopes: environment.msal.SCOPES,
        authority: environment.msal.AUTHORITY
      };

      const msalResponse = await this.msalInstance.loginPopup(loginRequest);

      if (msalResponse) {
        console.log(msalResponse)
        const repoService = this.injector.get(RepoService);
        let data = await repoService.getFirebaseToken(msalResponse.accessToken, msalResponse.account.localAccountId)
        await signInWithCustomToken(this.authFirebase, data.token);

      }

    } catch (error) {
      console.error("MSAL login failed:", error);
      return null;
    }
  }

  async acquireToken(): Promise<string> {
    let account = this.msalInstance.getAllAccounts()[0];

    // Try to recover account if missing but we know the user
    if (!account && this.userEmail) {
      try {
        console.log("No account found in cache, attempting ssoSilent with email:", this.userEmail);
        const ssoResponse = await this.msalInstance.ssoSilent({
          scopes: environment.msal.SCOPES,
          authority: environment.msal.AUTHORITY,
          loginHint: this.userEmail
        });
        return ssoResponse.accessToken;
      } catch (ssoError) {
        console.warn("ssoSilent failed:", ssoError);
        // Fall through to error
      }
    }

    if (!account) {
      throw new Error("No active account found");
    }

    console.log(account)

    const accessTokenRequest = {
      scopes: environment.msal.SCOPES,
      account: account,
      authority: environment.msal.AUTHORITY
    };

    try {
      const response = await this.msalInstance.acquireTokenSilent(accessTokenRequest);

      console.log(response)

      return response.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response = await this.msalInstance.acquireTokenPopup(accessTokenRequest);

          return response.accessToken;
        } catch (popupError) {
          console.error("Popup token acquisition failed:", popupError);
          throw popupError;
        }
      }
      console.error("Silent token acquisition failed:", error);
      throw error;
    }
  }


  ///Not used atm
  async signInWithEmail(email: string, password: string) {

    try {

      let t = await signInWithEmailAndPassword(this.authFirebase, email, password);
      console.log(t)
    } catch (e) {
      console.log(e)
    }

  }
}
